import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Space,
  Spin,
  Switch,
} from 'antd';
import { isEmpty, sortBy } from 'lodash';
import debounce from 'lodash.debounce';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PromotionApi from '../../functions/api/booking/PromotionApi';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import VehiclePartner from '../../functions/api/partner/VehiclePartner';
import TypeApi from '../../functions/api/vehicle/TypeApi';
import VehicleApi from '../../functions/api/vehicle/VehicleApi';
import ConvertPromotion from '../../functions/ConvertPromotion';

const PromotionDateType = {
  BY_CREATED_DATE: 'BY_CREATED_DATE',
  BY_START_DATE: 'BY_START_DATE',
};

const formItemLayout = {
  wrapperCol: { span: 24 },
  labelCol: { span: 24 },
};

const CAR = {
  type: 1,
  name: 'Ô tô',
};

const MOTO = {
  type: 2,
  name: 'Xe máy',
};

class FormAddPromotion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      promo_code: '',
      vehicles: [],
      partners: [],
      vehicle_partner: [],
      promo_code_exist: false,
      promotion_date_type: PromotionDateType.BY_CREATED_DATE,
      isEdit: !!props.match.params.promo_id,
      vehicle_type_applicable: [],
      options: [],
      promo: [],
    };
    // Delay call check promo_code exist 2 seconds
    this.checkPromoCodeExist = debounce(this.checkPromoCodeExist, 2000);
  }
  formRef = React.createRef();

  getOptionTypes = async (types) => {
    return types.map((item) => {
      return {
        label: item.vhc_type_name,
        value: item.vhc_type_name,
      };
    });
  };

  componentDidMount = async () => {
    const types = await TypeApi.getAll();
    const options = await this.getOptionTypes(types);

    let vehicles = await VehicleApi.getVehicles();
    vehicles = sortBy(vehicles, ['vhc_slug']);

    let partners = await PartnerApi.getAll();
    partners = sortBy(partners, ['part_name']);

    this.setState({ vehicles, partners, options });
    if (
      this.props.match.params &&
      this.props.match.path === '/promotion/edit-promotion/:promo_id'
    ) {
      const promo_id = this.props.match.params.promo_id;
      let detail = await PromotionApi.getDetailsPromotionByIdOrCode(promo_id);

      detail[0].promo_active = moment(detail[0].promo_active);

      detail[0].promo_expire = moment(detail[0].promo_expire);

      let vehicle_partner = await VehiclePartner.getAllVehiclePartner({
        part_id: detail[0].part_id,
      });
      vehicle_partner = sortBy(vehicle_partner, ['vhc_part_name']);

      detail[0].vehicle_type_applicable = JSON.parse(
        detail[0].vehicle_type_applicable
      ).map((b) => {
        if (b === CAR.type) {
          return CAR.name;
        }
        return MOTO.name;
      });

      this.setState({
        ...detail[0],
        vehicle_partner,
        options: options,
        promo: detail[0],
      });
    }
  };

  handleInputPromoCode = async (event) => {
    const promo_code = event.target.value;

    this.setState({ [event.target.name]: event.target.value });

    this.checkPromoCodeExist(promo_code);
  };

  checkPromoCodeExist = async (promo_code) => {
    const promotion = await PromotionApi.getDetailsPromotionByIdOrCode(
      promo_code
    );
    this.setState({ promo_code_exist: !isEmpty(promotion) });
  };

  handleChangePartner = async (event) => {
    const vhc_part_id = event;

    let vehicle_partner = await VehiclePartner.getAllVehiclePartner({
      part_id: vhc_part_id,
    });
    vehicle_partner = sortBy(vehicle_partner, ['vhc_part_name']);

    this.setState({ part_id: vhc_part_id, vehicle_partner });
  };

  handleCreate = async (values) => {
    let payload = {
      ...values,
      promo_id: this.props.match.params.promo_id,
    };

    payload.vehicle_type_applicable = payload.vehicle_type_applicable.map(
      (b) => {
        if (b === CAR.name) {
          return CAR.type;
        }
        return MOTO.type;
      }
    );

    if (!payload.is_active) {
      payload.is_active = 0;
    }
    if (!payload.is_show) {
      payload.is_show = 0;
    }

    var errors = ConvertPromotion.handleCheck(payload);
    if (errors) {
      errors.forEach(message.error);
      return;
    }
    const promotion = ConvertPromotion.handleNew(payload);
    let result;
    if (this.state.isEdit) {
      result = await PromotionApi.update(promotion.promo_id, promotion);
    } else result = await PromotionApi.create(promotion);

    if (result && !result['message']) {
      message.success('Đã lưu');
    } else {
      message.error('Lỗi');
    }
  };

  onSelectedChangeActive = (checked) => {
    this.formRef.current.setFieldsValue({
      is_active: checked ? 1 : 0,
    });
  };
  onSelectedChangeShow = (checked) => {
    this.formRef.current.setFieldsValue({
      is_show: checked ? 1 : 0,
    });
  };

  render() {
    const {
      promo_code,
      vehicles,
      partners,
      vehicle_partner,
      isEdit,
      promotion_date_type,
      options,
      promo,
      promo_code_exist,
    } = this.state;

    if (!promo_code && isEdit) {
      return <Spin />;
    }

    return (
      <>
        <h1>{isEdit ? 'Sửa khuyến mại' : 'Thêm khuyến mại'}</h1>

        <Form
          {...formItemLayout}
          onFinish={this.handleCreate}
          initialValues={promo}
          ref={this.formRef}
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name={['promo_code']}
                label="Code khuyến mại"
                rules={[{ required: true }]}
                extra={
                  promo_code_exist ? (
                    <p className="text-danger">Mã giảm giá đã tồn tại</p>
                  ) : null
                }
              >
                <Input onChange={this.handleInputPromoCode} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['promo_val']}
                label="Giá trị giảm"
                rules={[{ required: true }]}
                extra="*Nhỏ hơn 100 là giảm theo %; Lớn hơn 100 là giảm theo vnđ"
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vehicle_type_applicable']}
                label="Chọn loại xe được áp dụng"
                rules={[{ required: true }]}
              >
                <Select
                  mode="multiple"
                  showArrow
                  style={{ width: '100%' }}
                  options={options}
                  allowClear={true}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['number_of_use_max']}
                label="Số lần sử dụng tối đa"
              >
                <InputNumber
                  placeholder="Số lần sử dụng tối đa"
                  name="number_of_use_max"
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['promo_val_max']}
                label="Số tiền khuyến mãi tối đa"
              >
                <InputNumber
                  placeholder="Số tiền khuyến mãi tối đa"
                  name="promo_val_max"
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['promo_atleast_day']}
                label="Số ngày đặt xe tối thiểu"
                extra="Số ngày đặt xe tối thiểu để được áp dụng mã giảm giá"
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item name={['vhc_id']} label="Áp dụng cho dòng xe">
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(vehicles, ['vhc_name']).map((v) => ({
                    value: v.vhc_id,
                    label: `${v.vhc_bran_name} ${v.vhc_modl_name} ${v.vhc_name}  `,
                  }))}
                  allowClear={true}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name={['part_id']} label="Áp dụng cho đối tác">
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(partners, ['part_name']).map((p) => ({
                    value: p.part_id,
                    label: p.part_name,
                  }))}
                  allowClear={true}
                  onChange={this.handleChangePartner}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['vhc_part_id']}
                label="Áp dụng cho xe cụ thể của đối tác"
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(vehicle_partner, ['vhc_part_name']).map(
                    (vp) => ({
                      value: vp.vhc_part_id,
                      label: vp.vhc_part_name,
                    })
                  )}
                  allowClear={true}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['promo_active']}
                label="Bắt đầu"
                rules={[{ required: true }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['promo_expire']}
                label="Kết thúc"
                rules={[{ required: true }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['promotion_date_type']}
                label="Điều kiện ngày"
                rules={[{ required: true }]}
              >
                <Select
                  className="select-partner input-normal full-width"
                  value={promotion_date_type}
                >
                  <Select.Option value={PromotionDateType.BY_CREATED_DATE}>
                    Tính theo ngày tạo booking
                  </Select.Option>
                  <Select.Option value={PromotionDateType.BY_START_DATE}>
                    Tính theo ngày nhận xe
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['booking_created_from']}
                label="Áp dụng cho booking được tạo từ đâu"
                rules={[{ required: true }]}
              >
                <Select
                  options={[
                    {
                      value: 'web',
                      label: 'Tạo từ website',
                    },
                    {
                      value: 'app',
                      label: 'Tạo từ app',
                    },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item name="is_active" label="Kích hoạt khuyến mại">
                <Switch
                  onChange={this.onSelectedChangeActive}
                  checkedChildren="On"
                  unCheckedChildren="Off"
                  defaultChecked={promo.is_active}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="is_show" label="Hiển thị khuyến mại lên Website">
                <Switch
                  onChange={this.onSelectedChangeShow}
                  checkedChildren="On"
                  unCheckedChildren="Off"
                  defaultChecked={promo.is_show}
                />
              </Form.Item>
            </Col>
          </Row>
          <Space>
            <Button htmlType="submit" type="primary">
              Lưu
            </Button>
            <Link to="/promotion" type="secondary" component={Button}>
              Quay lại
            </Link>
          </Space>
        </Form>
      </>
    );
  }
}

export default FormAddPromotion;
